<template>
  <v-app>
    <NavbarRM v-if="token && $route.path.split('/')[1] == 'patient'" />
    <NavbarPOS
      v-else-if="
        token &&
        ($route.path.split('/')[1] == 'master' ||
          $route.path.split('/')[1] == 'stock' ||
          $route.path.split('/')[1] == 'pos' ||
          $route.path.split('/')[1] == 'report' ||
          $route.path.split('/')[1] == 'log-aktifitas' ||
          ($route.path.split('/')[1] == 'dashboard' &&
            $route.path.split('/')[2] == 'pos'))
      "
    />
    <NavbarPortal
      v-else-if="
        token &&
        ($route.path.split('/')[1] == 'content' ||
          $route.path.split('/')[1] == 'consultant' ||
          $route.path.split('/')[1] == 'partner' ||
          $route.path.split('/')[1] == 'setting' ||
          ($route.path.split('/')[1] == 'dashboard' &&
            $route.path.split('/')[2] == 'general'))
      "
    />
    <NavbarELearning
      v-else-if="
        token &&
        ($route.path.split('/')[1] == 'kelas')
      "
    />

    <NavbarEcommerce
      v-else-if="
        token &&
        ($route.path.split('/')[1] == 'e-commerce')
      "
    />

    <NavbarAke
      v-else-if="
        token &&
        ($route.path.split('/')[1] == 'ake')
      "
    />
    <Navbar v-else-if="token && $route.path != '/' && $route.path != '/404'" />
    <v-main
      min-height="80%"
      light
      :class="$route.path.split('/')[1] === 'patient' ? 'font-rekam' : ''"
    >
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { get, post, put, destroy } from "./service/Axios";
const Navbar = () =>
  import(/* webpackChunkName: "navbar" */ "@/components/Navbar.vue");
const NavbarRM = () =>
  import(/* webpackChunkName: "navbar" */ "@/components/navbar/NavbarRM.vue");
const NavbarPOS = () =>
  import(/* webpackChunkName: "navbar" */ "@/components/navbar/NavbarPOS.vue");
const NavbarPortal = () =>
  import(/* webpackChunkName: "navbar" */ "@/components/navbar/NavbarPortal.vue");
const NavbarELearning = () =>
  import(/* webpackChunkName: "navbar" */ "@/components/navbar/NavbarELearning.vue");
  const NavbarEcommerce = () =>
  import(/* webpackChunkName: "navbar" */ "@/components/navbar/NavbarEcommerce.vue");
  const NavbarAke = () =>
  import(/* webpackChunkName: "navbar" */ "@/components/navbar/NavbarAke.vue");
export default {
  components: {
    Navbar,
    NavbarRM,
    NavbarPOS,
    NavbarPortal,
    NavbarELearning,
    NavbarEcommerce,
    NavbarAke
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  watch: {
    $route(to, from) {},
  },
  methods: {},
  created() {
    if (process.browser) {
      if ("Notification" in window && "serviceWorker" in navigator) {
      }
    }
  },
};
</script>

<style>
#app {
  font-family: 'Merriweather' !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

#content {
  padding: 0px;
}
.font-rekam {
  font-family: 'Merriweather' !important;
}
</style>

<style lang="scss">
  .v-application {
    .text-h3 { // To pin point specific classes of some components
      font-family: 'Merriweather' !important;
    }
    .text-h4 { // To pin point specific classes of some components
      font-family: 'Merriweather' !important;
    }
    .text-h5 { // To pin point specific classes of some components
      font-family: 'Merriweather' !important;
    }
    .text-h6 { // To pin point specific classes of some components
      font-family: 'Merriweather' !important;
    }
    .body-1 { // To pin point specific classes of some components
      font-family: 'Merriweather' !important;
    }
    .body-1 { // To pin point specific classes of some components
      font-family: 'Merriweather' !important;
    }
    .body-2 { // To pin point specific classes of some components
      font-family: 'Merriweather' !important;
    }
    .caption { // To pin point specific classes of some components
      font-family: 'Merriweather' !important;
    }
    .title { // To pin point specific classes of some components
      font-family: 'Merriweather' !important;
    }
    .col {
      font-family: 'Merriweather' !important;
    }
    div {
      font-family: 'Merriweather' !important;
    }
  }
</style>
